import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5bfc153c"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterMarks: require('/var/www/components/Footer/footer-marks.vue').default,Footer: require('/var/www/components/Footer/footer.vue').default})
